import { render } from "./residentCreateAttendanceReport.vue?vue&type=template&id=11f8e7b4&ts=true"
import script from "./residentCreateAttendanceReport.vue?vue&type=script&lang=ts"
export * from "./residentCreateAttendanceReport.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__